<template>
  <div style="width: 70vw; min-height: 70vh; margin: 0 auto">
    <el-row>
      <div style="width: 600px; overflow: hidden; margin: 30px auto">
        <el-input style="width: 88%; float: left" v-model="inputValue" placeholder="请输入内容" @change="valueChange">
        </el-input>
        <el-button type="primary" style="float: left; width: 12%" @click="seachbykey2">搜索</el-button>
      </div>
    </el-row>
    <el-row>
      <div>
        <div style="
            font-size: 24px;
            border-bottom: 1px solid #1a73e7;
            text-align: left;
          ">
          {{ inputValue1
          }}<span style="font-size: 16px; margin-left: 10px">搜索结果</span>
        </div>
        <el-table :data="tableData" :show-header="false" style="width: 100%" @row-click="gotoDetails"
          row-class-name="rowClass">
          <el-table-column prop="title">
            <template slot-scope="scope">
              <div v-html="scope.row.title"></div>
            </template>
          </el-table-column>
          <el-table-column align="right" prop="publishDate"> </el-table-column>
        </el-table>
        <el-pagination style="margin: 30px 0" background layout="prev, pager, next,sizes" :total="total"
          @current-change="handleCurrentChange" :current-page.sync="currentPage2" @size-change="handleSizeChange"
          :page-sizes="[10, 20, 30, 40]" :page-size="pageSize">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage2: 1,
      total: 0,
      pageSize: 10,
      inputValue: this.$route.query.inputValue,
      inputValue1: this.$route.query.inputValue,
      tableData: [],
    };
  },
  mounted() {
    this.seachbykey();
  },
  methods: {
    valueChange() {
      this.$bus.$emit('inputValue', this.inputValue);
    },
    seachbykey2() {
      this.currentPage2 = 1;
      this.seachbykey();
    },
    seachbykey() {
      this.inputValue1 = this.inputValue;
      let value = {};
      value.keyword = this.inputValue;
      const url = `/api/v1/portal/search/search/${this.currentPage2}/${this.pageSize}`;
      this.axios.post(
        url,
        value,
        {},
        (resp) => {
          if (resp && resp.status === 200) {
            console.log(resp);
            this.tableData = resp.data.list;
            this.total = resp.data.total;
          }
        },
        // (error) => {
        //   console.error(error);
        //   this.$message({
        //     type: "error",
        //     message: "查询失败",
        //   });
        // }
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.seachbykey();
    },
    handleCurrentChange(val) {
      this.currentPage2 = val;
      this.seachbykey();
    },
    /**
     * 跳转到新闻详情页面
     * @param ：row  当前列表行数据行
     * @author ： 吴俊迪 wujundi
     */
    gotoDetails(row) {
      console.log(row);
      this.$router.push({
        path: '/wwnry',
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>
<style>
.rowClass {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/page/gtfy.vue